import React from "react";

const SpinIcon = ({ title, ...props }) => (
  <svg
    version="1.1"
    viewBox="0 0 976 406.9"
    style={{ enableBackground: "new 0 0 976 406.9" }}
    {...props}
  >
    {title ? <title>{title}</title> : null}
    <g>
      <path
        d="M645.8,364.7c2.5-10.4,4.8-20.8,7.4-31.2c13.8-55.4,27.6-110.7,41.4-166.1c4.6-18.5,9.3-37.1,13.8-55.6
  		c0.7-2.9,1.7-3.6,4.7-2.9c24.2,6.1,48.4,12.2,72.7,18.1c2.8,0.7,4,2,4.7,4.7c19.8,70.6,39.7,141.1,59.6,211.7
  		c0.4,1.3,0.9,2.6,2.3,3.9c1.7-6.8,3.5-13.6,5.2-20.4c13.8-55.6,27.7-111.3,41.5-166.9c0.6-2.5,1.5-4.3,4.6-3.5
  		c21.7,5.5,43.4,11,65.1,16.4c0.4,0.1,0.8,0.4,1.1,0.6c0,0.9,0,1.7,0,2.6c-0.6,1.6-1.4,3.1-1.8,4.7C955.1,233.4,942,286,928.9,338.6
  		c-2.2,8.7-4.1,17.4-6.1,26.1c-46.3,0-92.6,0-138.9,0c-11.2-39.8-22.3-79.5-33.9-120.6c-0.9,3-1.6,4.7-2,6.5
  		c-3.2,12.9-6.4,25.7-9.6,38.6c-6.3,25.2-12.6,50.4-18.9,75.5C695,364.7,670.4,364.7,645.8,364.7z"
      />
      <path
        d="M123.5,42.3c-1.4,1.5-2.9,2.8-4.1,4.4c-7,9.3-6.4,20.9,2.8,27.9c7.4,5.6,15.9,10.1,24.4,14
  		c16.2,7.3,33,13.4,49.3,20.8c14,6.4,26.6,15,37.6,25.9c22,21.7,29.1,48.1,24.3,78c-2.7,17-8.5,32.8-18.8,46.8
  		c-15.6,21.1-37.2,32.1-62.6,36.9c-7.8,1.5-14.7-1.1-21.8-2.8c-32.6-8-65.1-16.3-97.6-24.2c-6.8-1.7-11.5-6.2-16.4-10.4
  		c-19-16.4-31-36.7-33.6-62.1c-0.1-1.1-0.6-2.2-0.9-3.3c0-3.7,0-7.4,0-11.1c0.9-4.6,1.9-9.2,2.6-13.8c0.6-3.8,1.9-5.3,6.2-4.2
  		c20.8,5.4,41.8,10.6,62.7,15.7c3,0.7,4.5,1.8,3.5,5.3c-0.6,2.1-0.4,4.6,0.2,6.7c2.3,9.4,8.7,15.9,16.2,21.4
  		c15.1,10.9,32.3,15.5,50.7,15.8c8.2,0.1,16.2-1.5,23.4-5.9c13.2-8.1,16.6-24.8,7.2-37.1c-3-3.9-6.6-7.8-10.8-10.2
  		c-9.2-5.1-18.6-10-28.4-13.7c-21.4-8.1-42.6-16.5-61.3-30c-26.9-19.4-41.1-44.9-37.5-78.9c0.4-4,1-7.9,1.5-11.8
  		C69.2,42.3,96.3,42.3,123.5,42.3z"
      />
      <path
        d="M525.7,364.7c21-84.6,42.1-169.1,63.1-253.7c2.3-9.1,4.7-18.2,6.9-27.4c0.7-3,1.9-3.6,4.8-2.9
  		c20.7,5.3,41.5,10.5,62.3,15.6c2.8,0.7,3.6,1.6,2.9,4.7c-13.4,53.5-26.7,107.1-40,160.7c-8.3,33.4-16.6,66.7-24.9,100.1
  		c-0.2,0.9-0.3,1.9-0.4,2.9C575.5,364.7,550.6,364.7,525.7,364.7z"
      />
      <path
        d="M270.2,42.3c6.1,16.9,6.4,34,2.3,51.4c-0.9,3.8-2.4,4.7-6.2,3.7c-20.6-5.2-41.3-10.2-61.9-15.1
  		c-3.3-0.8-4.9-1.8-3.9-5.8c2.8-10.9-2.3-19.2-9.7-26.3c-3.2-3-7.1-5.3-10.6-7.9C210.1,42.3,240.1,42.3,270.2,42.3z"
      />
      <path
        d="M546.3,138.9c-4.1-45.4-33.5-79.7-77.7-90.9c-7-1.8-14-3.8-21-5.8c-38.9,0-77.8,0-116.6,0
  		c-0.2,0.4-0.4,0.8-0.5,1.2c-14.8,59.5-29.6,119-44.4,178.5c-7.8,31.1-15.6,62.2-23.3,93.4c-1.4,5.5-1.3,5.5,4,6.9
  		c19.6,4.9,39.3,9.9,58.9,14.8c5.4,1.4,5.5,1.4,7-4.4c6.3-25,12.5-50.1,18.8-75.1c2-8.1,4.1-16.2,6.1-24.4c1.5,0.2,2.5,0.2,3.5,0.4
  		c17.4,4.3,35,8.4,52.3,13.2c19.7,5.4,39.3,6.6,59.1,0.9C519.1,234.3,550.8,187.8,546.3,138.9z M459.2,176.5
  		c-8.1,5.8-17.2,7.4-26.9,5c-18.3-4.6-36.6-9.1-54.8-13.7c-0.9-0.2-1.9-0.6-3.4-1.2c5.6-22.6,11.2-45.1,16.9-67.9
  		c12.1,3,23.7,5.8,35.3,8.7c7.5,1.8,15,3.7,22.4,5.6c15.5,3.9,23.7,14.6,25.9,29.6C476.9,156.9,470.9,168.2,459.2,176.5z"
      />
    </g>
  </svg>
);

export default SpinIcon;
